export const updateArray = <T,>(items: T[], index: number, patch: Partial<T>): T[] =>
  items.map((item, i) => (i === index ? { ...item, ...patch } : item));

export const resequenceArray = <T extends { seqno?: number }>(items: T[]): T[] =>
  items.map((item, i) => ({ ...item, seqno: i + 1 }));

export const removeArray = <T extends { seqno?: number }>(items: T[], index: number): T[] =>
  resequenceArray(items.filter((_, i) => i !== index));
